export const ROLE_ADMIN = "admin";
export const ROLE_PROJECT_ADMIN = "project_admin";
export const PROJECT_ADMIN_ROLE_ID = 2;

// Form Admin, Form User, Viewer
export const PROJECT_ADMIN_ASSIGNABLE_ROLE_IDS = [4, 5, 6];

// Roles with a precedence level; only Crane Admin may change these users
export const LEVELED_ROLE_NAMES = [ROLE_ADMIN, ROLE_PROJECT_ADMIN];

export const USER_FORM_FIELDS = [
  "name",
  "email",
  "password",
  "password_confirmation",
  "title",
  "role",
  "lang",
  "groups",
  "projects",
];

// Form field -> API payload key
const FIELD_PAYLOAD_KEYS = {
  name: ["name"],
  email: ["email"],
  password: ["password"],
  title: ["title"],
  role: ["application_role_id"],
  lang: ["lang"],
  groups: ["groups"],
  projects: ["projects"],
};

export const projectAdminCompanyEditFields = ["projects"];

export const isProjectAdmin = (user) =>
  user?.role?.name === ROLE_PROJECT_ADMIN;

export const allowedRoleOptions = (currentRole, roles = []) => {
  if (currentRole?.name === ROLE_PROJECT_ADMIN) {
    return roles.filter((role) =>
      PROJECT_ADMIN_ASSIGNABLE_ROLE_IDS.includes(Number(role.id))
    );
  }
  return roles.filter((role) => role.id >= currentRole?.id);
};

export const editableUserFields = (authUser, targetUser, sharesProject) => {
  if (!isProjectAdmin(authUser) || !targetUser) return USER_FORM_FIELDS;

  if (String(targetUser.id) === String(authUser.id)) {
    return USER_FORM_FIELDS.filter((field) => field !== "role");
  }

  const targetRoleName = targetUser.application_role?.name;
  if (LEVELED_ROLE_NAMES.includes(targetRoleName)) return [];

  return sharesProject ? ["role", "groups", "projects"] : ["projects"];
};

export const pickEditablePayload = (payload, fields) =>
  fields.reduce((picked, field) => {
    (FIELD_PAYLOAD_KEYS[field] || []).forEach((key) => {
      if (payload[key] !== undefined) picked[key] = payload[key];
    });
    return picked;
  }, {});

// The list API marshals a missing role as { id: 0, name: null }, so check the id
export const isReducedUserRow = (row) => !row?.application_role?.id;

export const sharesProjectWith = (targetUser, memberProjects = []) => {
  const memberIds = memberProjects.map((project) => String(project.id));
  return (targetUser?.projects || []).some((project) =>
    memberIds.includes(String(project.id))
  );
};
